import React from 'react';
import Table from 'react-bootstrap/Table';

export default function InstructorClassesTable({ classes }) {
  return (
    <Table striped bordered hover className="custom-table">
      <thead>
      <tr>
        <th>Course</th>
        <th>Schedule</th>
        <th>Number of Students</th>
      </tr>
      </thead>
      <tbody>
      {classes.length > 0 ? (
        classes.map((classItem) => (
          <tr key={classItem.id}>
            <td>{classItem.className}</td>
            <td>{classItem.schedule}</td>
            <td>{classItem.students ? classItem.students.length : 0}</td>
          </tr>
        ))
      ) : (
        <tr>
          <td colSpan="3" className="text-center text-muted">
            No classes found.
          </td>
        </tr>
      )}
      </tbody>
    </Table>
  );
}
